import React, { useEffect, useRef, useState } from 'react';
import { InputProp } from '../../utils/tsConfig';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { v4 as uuid } from 'uuid';

const File: React.FC<InputProp> = (props) => {
	const { keyId, setState, state, isArray, indexVal, arrayName, max, min, className, returnKey, fieldName, onChange, required = false, disabled = false } = props;
	const [selected, setSelected] = useState<string | string[] | undefined>('');
	const [isDropdownVisible, setIsDropdownVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		if (returnKey && state?.[returnKey]) {
			setSelected(state[returnKey]);
		}
	}, [state, returnKey]);

	const handleFileUpload = async (file: File) => {
		try {
			setLoading(true);
			const storage = getStorage();
			const fileRef = ref(storage, `files/${uuid()}/${file.name}`);
			await uploadBytes(fileRef, file);
			const url = await getDownloadURL(fileRef);
			if (setState) {
				if (returnKey) {
					setState({ ...state, [returnKey]: url });
				}
			}
			setSelected(url);
		} catch (error) {
			console.error('File upload failed:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={`w-full ${className}`}>
			<label className='block text-sm font-medium text-gray-700'>{fieldName}</label>
			<div className='mt-1 flex items-center'>
				<input type='file' onChange={(e) => e.target.files && handleFileUpload(e.target.files[0])} disabled={disabled} className='block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border file:border-gray-300 file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200' />
				{loading && <span className='text-sm text-gray-500'>Uploading...</span>}
			</div>
			{/* <span className='input__label'>
				{fieldName.replace(/\*$/, '')}
				{fieldName.endsWith('*') && <span className='mandatory-asterisk'>*</span>}
			</span> */}
		</div>
	);
};

export default File;
